// hosts contains "localhost"
export default () => document.location.host.indexOf('localhost') === 0
